import React from 'react';
import PropTypes from 'prop-types';
import './AttendanceCard.css';

/**
 * AttendanceCard component for web interface
 * Displays a student's info and attendance status with ability to toggle
 */
const AttendanceCard = ({ student, status, onStatusChange }) => {
  // Helper functions
  const getInitial = () => {
    if (student && student.name) {
      return student.name.charAt(0).toUpperCase();
    }
    return '?';
  };

  const getStatusBadgeStyle = () => {
    if (status === 'present') {
      return {
        container: { backgroundColor: '#e8f5e9' },
        text: { color: '#2e7d32' }
      };
    } else if (status === 'absent') {
      return {
        container: { backgroundColor: '#ffcdd2' },
        text: { color: '#d32f2f' }
      };
    } else if (status === 'late') {
      return {
        container: { backgroundColor: '#ffe0b2' },
        text: { color: '#ff8f00' }
      };
    }
    
    // Default - no status selected
    return {
      container: { backgroundColor: '#f5f5f5' },
      text: { color: '#888888' }
    };
  };

  const getStatusText = () => {
    if (status === 'present') return 'Present';
    if (status === 'absent') return 'Absent';
    if (status === 'late') return 'Late';
    return 'Not Marked';
  };

  const getNextStatus = () => {
    if (!status || status === 'absent') {
      return 'present';
    } else if (status === 'present') {
      return 'late';
    } else if (status === 'late') {
      return 'absent';
    }
    return 'present'; // Default fallback
  };

  // Border style based on status
  const getBorderClass = () => {
    if (status === 'present') return 'present-border';
    if (status === 'absent') return 'absent-border';
    if (status === 'late') return 'late-border';
    return '';
  };

  return (
    <div className={`attendance-card ${getBorderClass()}`}>
      <div className="student-info">
        <div className="avatar-container">
          <span className="avatar-text">{getInitial()}</span>
        </div>
        <div className="details-container">
          <h3 className="name-text">{student.name}</h3>
        </div>
      </div>

      <button
        className="status-badge"
        style={getStatusBadgeStyle().container}
        onClick={() => onStatusChange(student._id, getNextStatus())}
      >
        <span style={getStatusBadgeStyle().text} className="status-text">
          {getStatusText()}
        </span>
      </button>
    </div>
  );
};

AttendanceCard.propTypes = {
  student: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  status: PropTypes.string,
  onStatusChange: PropTypes.func.isRequired
};

export default AttendanceCard;